import { Injectable } from '@angular/core';
import { Device } from '@capacitor/device';

export interface DeviceIdentity {
  DeviceId: string;
  Label: string;
  Platform: string;
}

/**
 * Identita' del telefono. Il gestionale accetta gli esiti solo dal dispositivo associato al corriere
 * (header X-Device-Id, US-APP-01): l'id deve restare lo stesso fra un avvio e l'altro. Su Android/iOS
 * e' l'identificativo di Capacitor; sul browser Capacitor lo genera e lo conserva nel localStorage.
 */
@Injectable({ providedIn: 'root' })
export class DeviceService {

  private identity: DeviceIdentity | null = null;

  async getIdentity(): Promise<DeviceIdentity> {
    if (this.identity) return this.identity;
    const [id, info] = await Promise.all([Device.getId(), Device.getInfo()]);
    const label = [info.manufacturer, info.model].filter(v => v && v !== 'unknown').join(' ').trim();
    this.identity = {
      DeviceId: id.identifier,
      Label: label || info.platform,
      Platform: info.platform,
    };
    return this.identity;
  }

  /** Id gia' letto, per l'interceptor (sincrono). Null finche' getIdentity non e' stato chiamato. */
  get currentId(): string | null {
    return this.identity?.DeviceId ?? null;
  }
}
